/*
 Author: Shivakumar
 Date: 06/04/2020
 Issue:[Payroll Wizard][Earnings and Deduction]Not able to search the employee with code..
 search_string: PL_3029
 */

<template>
  <div class>
    <br />
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="uploadMethoRadio" :disabled="!ifTeamleaderAnchorPermission">
      <!-- <tl-radio
        name="uploadType"
        label="Manual"
        id="manualUpload"
        value="manualUpload"
        v-model="uploadMethod"
      /> -->
      <tl-radio
        name="uploadType"
        label="Bulk Upload"
        id="bulkUpload"
        value="bulkUpload"
        v-model="uploadMethod"
      />
    </div>
    <br />
    <div v-if="uploadMethod == 'manualUpload'">
      <div class="filters" :key="componentKey">
        <!-- <search-dropdown
          placeholder="Search Emplyee name/code"
          :employeeData="filterEmpData"
          @getList="filterData($event)"
          v-model="searchText"
          @empselected="(emp)=>selectedEmp(emp)"
        /> -->
        <!-- PL_3029 -->
        <search-dropdown
          label="Employee Code / Name"
          v-model="searchText"
          :employeeData="employeeData"
          @getList="searchEmployeeByNameCode($event)"
          @empselected="(emp)=>selectedEmp(emp)"
          :disabled="!ifTeamleaderAnchorPermission"
        />
        <!-- PL_3029 -->
      </div>
      <ctc-details-card
        class="cardClass"
        v-show="showCtcDetailsCard"
        :photo_url="empPhoto"
        :empName="empName"
        :empId="empCode"
        :empMail="empMail"
        :ctcDetails="true"
        :currCTC="currCtc"
        :revisedCTC="revisedCTC"
        :effDate="effDate"
        @click="closeCard"
      >
        <template v-if="revisedCTC && effectiveDate">
          <span class="details">
            Revised CTC:
            <b>{{ revisedCTC }}</b>
          </span>
          <br />
          <span class="details">
            Effective Date:
            <b>{{ effectiveDate }}</b>
          </span>
        </template>
      </ctc-details-card>
      <div class="input-label">Effective Date</div>
      <!-- This below line is remove in data picker tag in effecive date and comment it -->
      <!-- :dates-disabled="{to: new Date(new Date().setDate(new Date().getDate()-1))}" -->
      <date-picker
        :key="componentKey"
        class="customwidth margin-b-15px"
        @datevalue="(val)=>effectiveDate=val"
      />
      <!-- :value="fbpSettingsData.declarationEndDate"  -->
      <div class="reviseFilters" v-if="showCtcDetailsCard">
        <div class="fourColumnGrid">
          <tl-select
            label="Revised By"
            labelText="name"
            :value="revisedBy"
            :options="revisedByOptions"
            @change="(val)=>revisedBy = val ? val.name : null"
          />
          <tl-select
            v-if="revisedBy == 'Flat Amount'"
            labelText="name"
            label="Action"
            :value="reviseAction"
            :options="actionTypes"
            @change="(val)=>actionType = val ? val.name : null"
            />
          <div>
            <txt
            :label="revisedvalue"
            type="number"
            v-numeric-only
            v-maxchars="9"
            v-model="revisedCTC"
            />
          </div>
          <!-- <tl-select
            label="Apply To"
            :value="applyTo"
            labelText="name"
            :options="applyToOptions"
            @change="(val)=>applyOn = val"
          /> -->
          <btn class="calClass" text="Calculate" type="secondary" v-on:click="reviseSalary()" />
          <br>

          </div>
          <div class="adjustmargin">
            <b class="margin-a-35px">Current CTC: {{currCtc}}</b>

          <b class="margin-l-30px margin-a-35px">Revised CTC: {{newCtc}}</b>

        </div>
        <div class="revised-salary-msg" v-if="showNewCtcMsg">
          <b>Revised Salary component value should be equal to Revised CTC.</b>
        </div>
      </div>
      <br />
      <data-table
        :columns="columnNames"
        :tableData="masterSalaryData"
        :checkbox="false"
        :showinrow="false"
        :with-form="false"
      >
        <template v-slot:rowcontent="slotprops">
          <!-- This line removed by below txt component for unable to value -->
          <!-- :disabled="'revisedAmount'+slotprops.value.index" -->
          <txt
            type="number"
            v-float-only
            v-maxchars="9"
            v-model="masterSalaryData[slotprops.value.index].revisedAmount"
            v-if="slotprops.value.column.key=='revisedAmount'"
            v-focus="save"
            @blur="(val)=>checkField(masterSalaryData[slotprops.value.index].revisedAmount,slotprops.value.record)"
          />
          <p v-else>{{slotprops.value.record[slotprops.value.column.key]}}</p>
        </template>
      </data-table>
      <div class="totalDiv" v-if="masterSalaryData.length > 0"><h3>Total : {{updatedValue}}</h3></div>
    </div>
    <div class="bulkUploadClass" v-if="uploadMethod == 'bulkUpload'">
      <div class="download-btn">
        <download-button @downloadTemplate="getEmployeeTemplate()"></download-button>
      </div>
      <div class="margin-t-15px" :key="componentKeyupload">
        <upload-file :apiUrl="bulkUploadUrl" :params="{loggedInUser : loginId, financial_year : payrollYear }" @uploadTemplate="onUploadTemplate($event)" />
      </div>
    </div>
    <div class="modal" v-if="showWarningMsg">
      <div class="modal-content">
        <div class="success-icon">
          <img src="@/assets/warning_error.svg" />
        </div>
        <div class="success-text">
          <b>Are you sure you wish to make changes ?</b>
        </div>
        <div class="message-text">
          Old CTC:
          <b>{{currCtc}}</b>
          <img src="@/assets/right-arrow.svg" />
          New CTC:
          <b>{{newCtc}}</b>
        </div>
        <div class="effDateClass">
          Effective Date:
          <b>{{getFormattedDate(effectiveDate)}}</b>
        </div>
        <div class="popup-btns">
          <btn text="Cancel" type="secondary" @click="cancel" />
          <btn text="Confirm" type="primary" @click="confirm" />
        </div>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`${empName}'s Salary has been scheduled for revision.`"
      btnText="Back To Revision Salary"
      @back="backToSalaryDataPage"
    ></pop-up-message>
    <pop-up-message
      v-if="showBulkUploadSuccessMsg"
      :message="`${popupMessage}`"
      btnText="Back To Revision Salary"
      @back="back"
    >
    <template v-slot:bottomContent>
      <div class="custom-container" style="display: flex; gap: 20px;">
        <button class="btn-popup" type="button" @click="backSuccessPopUp()">Back To Revision Salary</button>
          <a v-if="logSheetUrl" :href="logSheetUrl" @click="downloadItem(logSheetUrl)">
            <img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
        </div>
        </template>
  </pop-up-message>

    <pop-up-message
      v-if="showErrorPopup"
      message=""
      popupType="Warning"
      :popupHeaderMessage="'Revision in Progress!!!'">
      <template v-slot:bottomContent>
        <div class=" margintop-0">
          <div class="Rectangle margintop-32">
            <span class="Information-message">{{ logMessage }}</span>
          </div>
        </div>
        <div>
          <h2>You can monitor Salary Revision in the dashboard.</h2>
          </div>
        <!-- <div class="margintop-32 custom-container">
          <a :href="logSheetUrl" @click="downloadItem(logSheetUrl)">
            <img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
        </div> -->
        <div class="popup-btn-group margintop-32 marginright">
          <button class="btn-popup" type="button" @click="backfromlogpopup()">Back To Revision Salary</button>
        </div>
      </template>
    </pop-up-message>
    <bottom-action-container>
      <btn-grp slot="end">
        <btn text="Back" type="secondary" @click="back" />
        <btn text="Revise Salary" type="primary" @click="save()" :disabled="!ifTeamleaderAnchorPermission || showNewCtcMsg"/>
      </btn-grp>
    </bottom-action-container>

    <bottom-action-container v-if="revisionType == 'Fixed Non CTC'">
      <btn-grp slot="end">
        <btn text="Back" type="secondary" @click="back" />
        <btn text="Save" type="primary" @click="saveFixedNonCtc" />
      </btn-grp>
    </bottom-action-container>
  </div>
</template>
<script>
import CtcDetailsCard from "@/components/dashboard/ctcDetailsCard.vue";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import successIcon from "@/components/success.vue";
import * as constants from "@/apis/constants.js";
import { api_variables } from "@/apis/variables.js";


export default {
  components: {
    CtcDetailsCard,
    SearchDropdown,
    successIcon
  },
  data() {
    return {
      showSuccessMsg: false,
      showWarningMsg: false,
      uploadMethod: "bulkUpload",
      revisedBy: "",
      reviseAction: "",
      revisedValue: "",
      searchText: "",
      applyOn: "",
      revisedByOptions: [],
      actionTypes: [],
      applyTo: "",
      applyToOptions: [],
      showEditInput: false,
      actionType: "",
      empId: "",
      empPhoto: null,
      empName: "",
      empMail: "",
      empCode: "",
      currCtc: "",
      revisedCTC: "",
      componentKey: 0,
      componentKeyupload:0,
      salary_structure_id: null,
      revisionType: "Select",
      revisionTypeOptions: [],
      effectiveDate: "",
      showCtcDetailsCard: false,
      showFixedNonCtcDetailsCard: false,
      showFixedNonCtcDetailsDataTable: false,
      effectiveDateNonCtc: "",
      savedFixedNonCtcDataTable: false,
      vpfType: "flat",
      masterSalaryData: [],
      columnNames: [
        {
          label: "ComponentName",
          key: "name"
        },
        {
          label: "Current Salary",
          key: "annual"
        },
          {
          label: "ComponentName",
          key: "name"
        },
        {
          label: "Revised Salary",
          key: "revisedAmount"
        }
      ],
      fixedNonCtcColumnNames: [
        {
          label: "Components",
          key: "components"
        },
        {
          label: "Current Amount",
          key: "currAmount"
        },
        {
          label: "",
          key: "radios"
        },
        {
          label: "Revised Amount",
          key: "revisedAmount"
        }
      ],
      salaryData: [],
      newCtc: 0,
      toast: false,
      errmsg: "",
      employeeData: [],
      filterEmpData: [],
      savedFixedNonCtcColumnNames: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Previous Amount",
          key: "prevAmt"
        },
        {
          label: "Revised Amount",
          key: "revisedAmt"
        }
      ],
      savedFixedNonCtcData: [],
      editrecord: {},
      reviseSalaryValue: false,
      role: "",
      showBulkUploadSuccessMsg: false,
      popupMessage: "",  
      bulkUploadUrl: api_variables.SERVICE_SALARY_REVISION_BULK_UPLOAD, 
      updatedValue: 0,
      showNewCtcMsg: false,
      sheetLoading: true,
      logSheetUrl: null,
      showErrorPopup: false,
      enableButton: false,
      componentKey1: 0
    };
  },
  activated() {
    this.refresh();
    this.setConstantsData();
    //this.fetchEmplDetails(); // fetch all employees
    this.getOrgLeIdList();
  },
  mounted() {
    this.refresh();
    this.setConstantsData();
    //this.fetchEmplDetails(); // fetch all employees
    //this.fetchSalaryStructures(); // fetch all salary structures
    this.getOrgLeIdList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      globalEmployeeList: state =>
        state.globalapi.globalemployees.entityWiseData,
      reviseSalaryData: state => state.dashboard.revisesalary.revisesalary,
      loginId:state=>state.auth.email,
      payrollYear: state => state.payroll.runpayroll.payrollYear

    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.reviseSalaryValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    },
    revisedvalue(){
      switch (this.revisedBy) {
        case "Hike in %":
          return "Enter value in %";
        case "Hike in value":
          return "Hike in value";
        case "New value":
          return "Enter New CTC";
        default:
          return "Enter value";
      }
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  },
  methods: {
    ...mapActions({
      act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
      act_create: "dashboard/payroll/utilities/revisesalary/create",
      act_fetchAll:
        "dashboard/payroll/utilities/revisesalary/fetchReviseSalary",
      act_fetchCtc:
        "dashboard/payroll/utilities/revisesalary/fetchCalculatedCtc",
      act_calculateSalary:
        "dashboard/payroll/utilities/revisesalary/calculateReviseSalary",
      fetchEmployeeByLeNameCode: "dashboard/payroll/utilities/addexitemployees/fetchLegalEntityNonExitsEmployeeSearchList",//PL_3029
      fetchEmpSalRevision: "dashboard/payroll/utilities/revisesalary/fetchSearchEmployeeList",
      fetch_template: "dashboard/payroll/utilities/revisesalary/getEmployeeTemplate",
      act_upload_template: "dashboard/payroll/utilities/revisesalary/uploadTemplate"
    }),

    backfromlogpopup(){
      this.showErrorPopup = false;
      this.componentKeyupload += 1;
    },
    backSuccessPopUp(){
     this.showBulkUploadSuccessMsg = false
     this.componentKeyupload += 1;
    },
    // PL_3029
    async searchEmployeeByNameCode(val){
      try {
        if (val && val.length > 2){
            let res = await this.fetchEmpSalRevision({
              le_id: this.le_id,
              key: val
            });
            if (res.data.status) {
              this.employeeData = res.data.payload.data;
            }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // PL_3029

    setConstantsData() {
      try {
        this.revisedByOptions =
          constants.ReviseSalaryConstants.revisedByOptionsNew;
        this.actionTypes = constants.ReviseSalaryConstants.actionTypes;
        this.applyToOptions =
          constants.ReviseSalaryConstants.applyToOptions;
        this.revisionTypeOptions =
          constants.ReviseSalaryConstants.revisionTypeOptions;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getEmployeeTemplate() {
       //console.log("Inside getEmployeeTemplate");
      try {
        let res = await this.fetch_template(this.le_id);
        //console.log(res);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    // async onUploadTemplate(event) {
    //   let formData = new FormData();
    //   formData.append("file", event);
    //   formData.append("le_id", this.le_id);
    //   try {
    //     let res = await this.act_upload_template(formData);
    //     if (res.status == 200 || res.status == 201) {
    //       this.popupMessage = res.message ? res.message : "";
    //       this.showBulkUploadSuccessMsg = true;
    //     }
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },

    /** BULK UPLOAD server call response handling */
    async onUploadTemplate(res) {
      try {
        if (res.data || res.status) {
          if(res.status == 200) {
            this.sheetLoading = true;
            this.showErrorPopup = true;
          } else {
            this.popupMessage = res.data.message;
            this.showBulkUploadSuccessMsg = true;
            this.enableButton = true;
             this.sheetLoading = false;
             if (res.data.payload && res.data.payload.length > 0 && res.data.payload[0].trim() !== "") {
              this.logSheetUrl = res.data.payload[0];
            } else {
              this.logSheetUrl = null
            }
            //  this.logSheetUrl = res.data.payload[0];
          }
        } else {
          this.toast = true;
          this.errmsg = res.response.data.message;
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    
    searchDataList(val) {
      this.getEmployeesByName(val);
    },
    async getEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByName(val);
        this.customEmpList = res.data.payload.data;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async fetchSalaryStructures() {
      try {
        let res = await this.act_fetchSalaryStructure(this.le_id);
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    setCtc() {
      try {
        this.newCtc = 0;
        if (this.revisedBy == "Flat Amount") {
          if (this.revisedCTC) {
            switch (this.actionType) {
              case "Add":
                this.newCtc = this.currCtc + this.revisedCTC;
                break;
              case "Subtract":
                this.newCtc = this.currCtc - this.revisedCTC;
                break;
              case "Replace":
                this.newCtc = this.revisedCTC;
                break;
              default:
                this.newCtc = this.revisedCTC;
                break;
            }
          } else {
            this.newCtc = this.currCtc;
          }
        } else {
          this.newCtc = this.revisedCTC + "%";
        }
        return this.newCtc;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async reviseSalary() {
      try {
        if (this.masterSalaryData.length) {
          for (let obj of this.masterSalaryData) {
            obj["calculationType"] = obj.calculation_type
              ? obj.calculation_type
              : obj.calculationType;
          }
          this.masterSalaryData = [...this.masterSalaryData];
        }
        let reqObj = {
          le_id:this.le_id,
          reviseBy: this.revisedBy,
          value: this.revisedCTC,
          currentCTC: this.currCtc,
          // ctcPercent: this.revisedBy == "Percentage" ? this.setCtc() : "",
          // currentCTC: this.revisedBy == "Percentage" ? this.currCtc : "",
          salary_details: {
            // ctc: this.revisedBy == "Percentage" ? "" : this.setCtc(),
            salaryComponents: this.masterSalaryData
          }
          // added by arushi - 25th nov for statutory calculations (ErPF, ErESIC)
          // pass these values of these
          // pfApplicable : ?true:false,
          // esiApplicable:?true:false,
          // le_id:this.le_id,
          // loc_id:location_id
        };
        try {
          let res = await this.act_calculateSalary(reqObj);
          if (res.data.payload.salary_detail.salaryComponents.length) {
            let tempArray = [];
            Object.assign(tempArray, this.masterSalaryData);
            //console.log(tempArray);
            tempArray.forEach(item => {
              res.data.payload.salary_detail.salaryComponents.forEach(
              (element, index) => {
                // The element.annual value replaced by monthly value element.monthly in below line 513
                if(item["id"] == element.id){
                  item["revisedAmount"] = element.annual;
                  item["difference"] =
                  element.annual - item.annual;
                }
              }
            );
            })
            this.masterSalaryData = tempArray;
            this.newCtc = res.data.payload.salary_detail.ctc;
            const totalAmount = this.masterSalaryData.reduce((total, i) => {
              total = total + i.revisedAmount;
              return total;
            }, 0)
            this.updatedValue = Math.round(totalAmount);
          }
          if (res.message != null) {
            throw Error(res.message);
          }
        } catch (err) {
          this.toast = true;
          this.errmsg = err;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    backToUploadPage() {
      this.showSuccessMsg = false;
    },
    getFormattedDate(event) {
      try {
        if (event) {
          return (
            new Date(event).getDate() +
            "-" +
            (new Date(event).getMonth() + 1) +
            "-" +
            new Date(event).getFullYear()
          );
        } else {
          return "";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    goToPayroll() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll`
      });
    },
    goToUtilities() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      });
    },
    back() {
      try {
        this.showBulkUploadSuccessMsg = false;
         this.componentKeyupload += 1;
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/revise_salary`,
         
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    viewReports() {
      this.showSuccessMsg = false;
    },
    backToDashboard() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll`
      });
    },
    editInput(record) {
      this.editrecord = record;
      this.showEditInput = true;
    },
    closeCard() {
      try {
        if (this.revisionType == "CTC") {
          this.showCtcDetailsCard = false;
        }
        if (this.revisionType == "Fixed Non CTC") {
          this.showFixedNonCtcDetailsCard = false;
        }
        this.unSelectedEmp();
        this.updatedValue= 0;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    save() {
      this.showWarningMsg = true;
    },
    async fetchEmplDetails() {
      let tempObj = {};
      try {
        let res = await this.act_fetchAllEmployees({ le_id: this.le_id });
        this.employeeData = res.data.payload.data;
        this.salaryData = [];
        if (res.data.payload.data.length) {
          for (let employee of res.data.payload.data) {
            (employee["name"] = employee.name),
              (employee["code"] = employee.code),
              (employee["email"] = employee.email_id),
              (employee["id"] = employee.id);
            employee["empSalarySettings"] = employee.EmployeeSalarySetting;
            for (let salarySettingObj of employee.empSalarySettings) {
              employee["currCtc"] = salarySettingObj.ctc;
            }
          }
          this.employeeData = [...res.data.payload.data];
        }
        for (var key in tempObj) {
          let salaryObj = {
            code: tempObj[key].name,
            currentSalary: tempObj[key].monthly,
            revisedSalary: tempObj[key].value
          };
          this.salaryData.push(salaryObj);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    saveFixedNonCtc() {
      try {
        let obj = {};
        obj.code = this.empId;
        obj.name = this.name;
        obj.prevAmt = this.prevAmt;
        obj.revisedAmt = this.revisedAmt;
        this.savedFixedNonCtcData.push(obj);
        this.savedFixedNonCtcDataTable = true;
        this.showFixedNonCtcDetailsDataTable = false;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    confirm() {
      this.showWarningMsg = false;
      this.performAction();
    },
    cancel() {
      this.showWarningMsg = false;
    },
    backToSalaryDataPage() {
      try {
        let record = {};
        this.showSuccessMsg = false;
        this.$emit("swichTab", 1, record);
        this.refresh();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    changeRevisionType(val) {},

    async performAction() {
      try {
        let reviseSalaryArray = [];
        let d = new Date();
        this.masterSalaryData.forEach((element, index) => {
          // let salaryObj = {
          //   name: element.name,
          //   id: element.id,
          //   code: element.abbreviation,
          //   category_code: element.abbreviation,
          //   calculationType: element.calculation_type
          //     ? element.calculation_type
          //     : element.calculationType,
          //   abbreviation: element.abbreviation,
          //   formula: element.formula,
          //   monthly: element.revisedAmount,
          //   annual: element.revisedAmount *12,
          // };
          // reviseSalaryArray.push(salaryObj);
          element.monthly = element.revisedAmount/12,
          element.annual = element.revisedAmount;
        });
        let reqObj = {
          data: {
            effective_date: this.effectiveDate,
            employee_id: this.empId,
            legal_entity_id: this.le_id,
            dateUpdated:
              d.getFullYear() +
              "-" +
              ("0" + (d.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + d.getDate()).slice(-2),
            salary_details: {
              ss_id: this.salary_structure_id,
              ctc: Math.round(this.newCtc),
              // salaryComponents: reviseSalaryArray
              salaryComponents: this.masterSalaryData,
            }
          }
        };
        try {
          this.$root._data.isSaving = false;
          let res = await this.act_create(reqObj);
          setTimeout(() => {
            if (res.data.status) {
              this.showSuccessMsg = true;
              this.$root._data.isSaving = false;
              let historyLength = res.data.payload.history_salary_structure ? res.data.payload.history_salary_structure.length : 0;
              this.effDate = (historyLength > 0) ?  res.data.payload.history_salary_structure[historyLength -1].from : "";
              this.currCtc = (historyLength > 0) ?  res.data.payload.history_salary_structure[historyLength -1].ctc : res.data.payload.ctc;
              //this.salary_structure_id = emp.EmployeeSalarySetting ? res.data.payload.salary_structure_id : null;
              this.masterSalaryData = (historyLength > 0) ?  res.data.payload.history_salary_structure[historyLength -1].details : res.data.payload.master_salary_structure;
              for (let element of this.masterSalaryData) {
                element["revisedAmount"] = 0;
              }
              this.masterSalaryData = [...this.masterSalaryData];
                // this.fetchEmplDetails();
              }
          }, 500);
        } catch (err) {
          this.$root._data.isSaving = false;
          this.toast = true;
          this.errmsg = err;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    searchData(key, array) {
      try {
        const final = [];
        for (let i = 0; i < array.length; i++) {
          let searchObj = array[i].first_name;
          if (
            searchObj != null &&
            searchObj.toLowerCase().search(key.toLowerCase()) !== -1
          ) {
            final.push(array[i]);
          }
        }
        return final;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    filterData(searchText) {
      try {
        let data = this.$_.cloneDeep(this.employeeData);
        if (searchText.length) {
          this.auto_suggestions = true;
          this.filterEmpData = this.searchData(searchText, this.employeeData);
        } else {
          this.auto_suggestions = false;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    locklist(ee) {
      if (ee) {
        this.lockList = "Yes";
      } else {
        this.lockList = "No";
      }
    },
    selectedEmp(emp) {
      try {
        this.unSelectedEmp();
        this.showCtcDetailsCard = true;

        this.empPhoto = emp.photo_url ? emp.photo_url : null;
        this.empName = emp.first_name ? emp.first_name : "";
        this.empCode = emp.code ? emp.code : "";
        this.empId = emp.id ? emp.id : null;
        this.empMail = emp.email_id ? emp.email_id: "";
        //this.currCtc = emp.currCtc;
        let historyLength = emp.EmployeeSalarySetting[0].history_salary_structure ? emp.EmployeeSalarySetting[0].history_salary_structure.length : 0;
        this.effDate = (historyLength > 0) ?  emp.EmployeeSalarySetting[0].history_salary_structure[historyLength -1].from : "";
        this.currCtc = (historyLength > 0) ?  emp.EmployeeSalarySetting[0].history_salary_structure[historyLength -1].ctc : emp.EmployeeSalarySetting[0].ctc;
        this.salary_structure_id =emp.EmployeeSalarySetting ? emp.EmployeeSalarySetting[0].salary_structure_id : null;
        this.masterSalaryData = (historyLength > 0) ?  emp.EmployeeSalarySetting[0].history_salary_structure[historyLength -1].details : emp.EmployeeSalarySetting[0].master_salary_structure;
        for (let element of this.masterSalaryData) {
          element["revisedAmount"] = 0;
        }
        this.masterSalaryData = [...this.masterSalaryData];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    unSelectedEmp() {
      try {
        this.showCtcDetailsCard = false;
        this.empPhoto = null;
        this.empName = "";
        this.empCode = null;
        this.empId = null;
        this.empMail = "";
        this.currCtc = "";
        this.effDate = null;
        this.salary_structure_id = null;
        this.masterSalaryData = [];
        this.masterSalaryData = [...this.masterSalaryData];
        this.refresh();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    refresh(){
      try {
        this.toast = false;
        this.errmsg = "";
        this.empId = null;
        this.revisedValue = null;
        this.applyTo = null;
        this.effectiveDate = null;
        this.revisedBy = null;
        this.reviseAction= null;
        this.actionType= null;
        this.revisedCTC= null;
        this.applyOn= null;
        this.newCtc= null;
        this.showCtcDetailsCard = false;
        this.empPhoto = null;
        this.empName = "";
        this.empCode = null;
        this.empId = null;
        this.empMail = "";
        this.currCtc = "";
        this.effDate = null;
        this.salary_structure_id = null;
        this.masterSalaryData = [];
        this.masterSalaryData = [...this.masterSalaryData];
        this.componentKey += 1;
        this.effectiveDate = null;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.reviseSalaryValue = data.data.user.permissions.revise_salary ? true : false;
        //console.log("PL-3406",data);
    },

    checkField(val, record) {
      const totalAmount = this.masterSalaryData.reduce((total, i) => {
        total = total + i.revisedAmount;
        return total;
      }, 0)
      this.updatedValue = Math.round(totalAmount);
      if(this.updatedValue == this.newCtc) {
                this.showNewCtcMsg = false;
      } else {
        this.showNewCtcMsg = true;
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.content {
  margin-left: 20px;
  margin-top: 15px;
}
.subtitle {
  width: 316px;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #646464;
}
.upload {
  background: none;
}
.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}
.uploadMethoRadio {
  display: flex;
}
.calClass {
  height: 0px;
  margin-top: 5%;
}
select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  // width: 93px;
  // height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.footer-width {
  width: 87%;
}
.selectdiv {
  select {
    width: 100%;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9f9da2;
    border: 1px solid #dadada;
    padding: 0 10px;

    &.errorr {
      border: 1px solid #e01717;
    }
    &.errorMessage {
      color: #e01717;
    }
  }
  span {
    font-size: 12px;
    margin-left: 3px;
    color: #9f9da2;
  }
}
.recent {
  align-self: self-end;
}
.filters {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 0.3fr 0.2fr 0.1fr 0.3fr 0.3fr;
  margin-bottom: 2%;
}

.totalDiv{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f1f5;
}

.totalDiv > h3 {
  margin-left: 460px;
}
.fourColumnGrid {
  display: grid;
  grid-template-columns: 0.2fr 0.2fr 0.2fr 0.2fr;
  grid-gap: 10px;
}
.filterbtn {
  width: 80%;
  height: 55%;
  border-radius: 4px;
  border: solid 1px #34c0be;
  color: #34c0be;
  grid-column: -1/ -2;
  align-self: self-end;
  padding: 10px;
  margin-bottom: 20px;
}
.inputbox {
  width: 100px;
  height: 35px;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.search-container {
  position: relative;
  display: flex;
}
.custom-width {
  width: 106px;
}
.custom-radio-align {
  margin-top: 36px;
}
.search-bar {
  width: 100%;
  border: 1px solid #d6d4d4;
  border-radius: 3px;
  height: 34px;
  padding: 0px 0 0 30px;
  position: relative;
}
.search-icon {
  position: absolute;
  margin-right: 10px;
  left: 10px;
  top: 8px;
  width: 15px;
  height: 15px;
}

.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

/* Modal Content */
.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  padding: 30px 36px 36px 36px;

  .success-icon {
    margin-bottom: 40px;
  }

  .success-text {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: auto;
  }

  .message-text {
    font-size: 14px;
    margin-bottom: auto;
  }

  .effDateClass {
    margin-bottom: 5%;
  }
  .popup-btns {
    display: flex;
    :nth-child(n) {
      margin-right: 15px;
    }
  }
}
.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 70%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 70%;
    margin-bottom: -6px;
  }
}
.lop-report {
  display: grid;
  grid-template-columns: 0.3fr 0.3fr 0.3fr auto;
  grid-gap: 10px;
}
.export-emp {
  float: right;
  margin-bottom: 1%;
  margin-top: 3%;
}
.export-section {
  margin-left: 12%;
  margin-top: 5px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 85px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 5px;
  margin-right: 10px;
}
.sorttext {
  // width: 10%;
  text-align: center;
  line-height: 30px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons {
  width: 13%;
  padding: 8px 0px 5px 10px;
  span {
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.cardClass {
  margin-bottom: 2%;
}
.download-btn {
  margin-top: 2%;
}
.customwidth {
  width: 245px;
}
.details {
  color: #979797;
  font-size: 11px;
  b {
    color: #535353;
  }
}
.width-160{
  width: 160px;

}
.adjustmargin{
  margin-top: 50px;
  margin-left: 385px;
}
.margin-l-30px{
  margin-left: 460px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}

.revised-salary-msg {
  background: #ffe1e1;
  border: 2px solid red;
  margin: 10px 0px;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  font-size: 1rem;
  color: #091218;
}
</style>
